import Debug from 'debug';
import buildCigObjectsUrl from "../util/cig-objects-url";
import Cig from "../util/Cig";
import cacheBust from "../util/cacheBust";

/**
 * Fired on the <pub-slug>?/create-password page
 */
export default {
	async init() {
		try {
			Debug(`cig:info:sage:route:createPassword`)(`init start`);

			// Get CIG Objects blob (for now change and create are the same in CIG Objects -- Hunter 2022.04.14)
			const url = await buildCigObjectsUrl('person', 'create-password.json');

			Cig.loadExternalScript(url, '#inline-create-password', () => console.log('CIG Objects Loaded'));

			// CIG Objects uses the same JS for Change Password and Create Password so the event is shared
			window.document.body.addEventListener(
				'cig.Account.ChangePassword.success',
				() => {
					const url = new URL(window.location);
					// What to do if we're missing the param?
					const redirectUrl = url.searchParams.get('login_redirect_url');
					if (redirectUrl) {
						const urlCb = cacheBust(redirectUrl);

						const cigobjectMainEl = window.document.querySelector('#inline-create-password .cigobjects');
						if (cigobjectMainEl) {
							// Hide the instructions and form elements
							const instructionEl = cigobjectMainEl.querySelector('.password-instructions');
							const formEl = cigobjectMainEl.querySelector('form');

							if (instructionEl) {
								instructionEl.style.display = 'none';
							}
							if (formEl) {
								formEl.style.display = 'none';
							}

							// Add redirect button
							const buttonEl = window.document.createElement('a');
							buttonEl.innerHTML = 'Go to Login';
							buttonEl.href = urlCb;
							buttonEl.style.display = 'block';
							buttonEl.style.margin = 'auto auto 30px';
							buttonEl.style.width = '150px';
							buttonEl.classList.add('btn', 'btn-large', 'btn-primary');
							cigobjectMainEl.appendChild(buttonEl);
						}
					}
				}
			);

		} catch (err) {
			Debug(`cig:error:sage:route:createPassword`)(`Create Password Route init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},

	// Fires after init
	finalize() {
		try {
			Debug(`cig:info:sage:route:createPassword`)(`finalize start`);

		} catch (err) {
			Debug(`cig:error:sage:route:createPassword`)(`Create Password Route finalize Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},
};
